export default __webpack_public_path__ + "static/media/clairefontaine6.0af8da49.jpg";